import { GET } from './request';

export const getCitiesList = () => {
  return GET('dictionaries/cities/values?orders[name]=asc');
};
